import { ListingHelper } from 'src/app/core/utils/listing.helper';

import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[sharedListingColumnWidth]',
})
export class SharedListingColumnWidthDirective {
  @Input() sharedListingColumnWidth!: ListingHelper;
  @Input() columnName!: string;

  @HostBinding('style.width') get widthVariable() {
    // note returns undefiend for default column
    const def = this.sharedListingColumnWidth.getColumn(this.columnName);
    if (def && def.type && def.type.fixed === true)
      return this.sharedListingColumnWidth.getWidth(this.columnName) + 'px';
    else
      return this.sharedListingColumnWidth.getWidth(this.columnName) + '%';
  }
}
